const links = [
  { href: "https://multipolar.acinvesting.fr/mentions-legales", label: "Mentions légales", testid: "footer-legal-link", external: true },
  { href: "https://multipolar.acinvesting.fr/cgv", label: "CGV", testid: "footer-cgv-link", external: true },
  { href: "https://multipolar.acinvesting.fr/politique-de-confidentialite", label: "Politique de confidentialité", testid: "footer-privacy-link", external: true },
  { href: "/gerer-mon-abonnement", label: "Gérer mon abonnement", testid: "footer-subscription-link", external: false },
  { href: "mailto:contact@acinvesting.fr", label: "Contact", testid: "footer-contact-link", external: false },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="pt-32 pb-14">
      <nav
        className="max-w-7xl mx-auto px-6 md:px-12 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-center"
        aria-label="Liens de pied de page"
      >
        {links.map((l, i) => (
          <span key={l.testid} className="flex items-center gap-3">
            <a
              href={l.href}
              data-testid={l.testid}
              {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              className="font-mono text-xs tracking-[0.1em] text-[#A3B8B0] hover:text-[#F5F5F0] transition-colors"
            >
              {l.label}
            </a>
            {i < links.length - 1 && <span className="text-[#758D85]" aria-hidden="true">·</span>}
          </span>
        ))}
      </nav>
    </footer>
  );
}
